var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClinicalStudiesIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 18,
    viewBox: "0 0 15 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.18464 16.2002C4.21384 16.2002 1.80456 13.7862 1.80456 10.825C1.80456 7.84455 5.2793 3.93788 7.18464 2.12372C9.09959 3.91388 12.5647 7.80136 12.5647 10.825C12.5647 11.0313 12.5551 11.2377 12.5263 11.4393L14.0381 12.9511C14.2445 12.2744 14.3645 11.5641 14.3645 10.825C14.3645 5.94881 8.03893 0.44874 7.76536 0.22317C7.42461 -0.0743901 6.93028 -0.0743901 6.58472 0.22317C6.32076 0.458339 0 6.0112 0 10.825C0 14.7844 3.22037 18 7.17984 18C8.41328 18 9.57472 17.6832 10.5922 17.1361L9.24357 15.7875C8.60525 16.0563 7.91415 16.2002 7.18464 16.2002Z",
    fill: "#003032"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1246 15.5715L10.2803 11.7272C10.6067 11.1849 10.7842 10.5658 10.7842 9.89868C10.7842 7.91655 9.17166 6.29916 7.18473 6.29916C5.19779 6.29916 3.58521 7.92135 3.58521 9.89868C3.58521 11.8856 5.19779 13.4982 7.18473 13.4982C7.84224 13.4982 8.47095 13.3158 9.00368 12.9943L12.848 16.8386C13.0303 17.0209 13.2511 17.0977 13.4863 17.0977C13.7215 17.0977 13.947 17.0161 14.1246 16.8386C14.475 16.4882 14.475 15.9219 14.1246 15.5715ZM7.18473 11.6984C6.19606 11.6984 5.38497 10.897 5.38497 9.89868C5.38497 8.91002 6.19606 8.09892 7.18473 8.09892C8.17339 8.09892 8.98448 8.91002 8.98448 9.89868C8.98448 10.897 8.17339 11.6984 7.18473 11.6984Z",
    fill: "#003032"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClinicalStudiesIcon);
export default __webpack_public_path__ + "static/media/clinical-studies-icon.95eb2dc1bd4b6cfeb97e477a18df391f.svg";
export { ForwardRef as ReactComponent };